import React from 'react';
import { IntercomProvider } from 'react-use-intercom';
import { isAdminOrSuperAdmin } from '@ApplicationWide/permissions/userTypes';
import { useAppConfig, useLoggedInUser } from '@ApplicationWide/AppConfig';
import { node } from 'prop-types';
import './SaplingIntercomProvider.less';

export default function SaplingIntercomProvider({ children }) {
  const { company, application } = useAppConfig();

  const { user } = useLoggedInUser();

  const isIntercomEnabled = isAdminOrSuperAdmin(user) && company?.baseDetails.intercomFeatureFlag;

  const autoBootProps = {
    email: user.email,
    userId: user.id,
    userHash: user.intercomUserHash,
    hideDefaultLauncher: true,
    alignment: 'right',
    horizontalPadding: 30,
    customAttributes: {
      job_title: user.title,
      role: user.userRole?.roleType,
      lastName: user.lastName,
      fullName: user.fullName,
      first_name: user.firstName,
      current_stage: user.currentStage,
      preferred_name: user.preferredName,
      preferred_full_name: user.displayName,
    },
    company: {
      name: company?.baseDetails.name,
      companyId:
        application?.intercom?.name === 'production'
          ? `${company?.id}`
          : `${company?.id}-${application?.intercom?.name}`,
    },
  };

  return (
    <IntercomProvider
      apiBase={application?.intercom?.apiBase}
      appId={application?.intercom?.intercomAppId}
      autoBoot={isIntercomEnabled}
      autoBootProps={autoBootProps}
    >
      {children}
    </IntercomProvider>
  );
}

SaplingIntercomProvider.propTypes = {
  children: node,
};
